import { Button, List, Row, Space } from 'antd'
import { usePayItemsModuleContext } from '../../../PayItemsModuleContext'
import EditOrderModal from '../../EditOrderModal'
import CIMSCollapse from 'components/CIMSCollapse'
import { getLabel } from '../../EditOrderModal/utils'
import GroupedListItem from '../../GroupedListItem'
import UngroupedListItem from '../../UngroupedListItem'

const Order: React.FC = () => {
  const { refetch, sorted, fetching } = usePayItemsModuleContext()
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Row justify="space-between">
        <EditOrderModal />
        <Button
          onClick={() => refetch()}
          disabled={fetching}
          loading={fetching}
        >
          Reload
        </Button>
      </Row>
      <List
        size="large"
        dataSource={sorted}
        renderItem={(item) => {
          if (item.__typename === 'PayItemConnectionGroup')
            return (
              <GroupedListItem key={item.id}>
                <CIMSCollapse
                  ghost
                  panels={[
                    {
                      key: item.id,
                      header: item.name,
                      children: !item.children.length ? null : (
                        <List
                          dataSource={item.children}
                          renderItem={(item) => (
                            <List.Item>{getLabel(item)}</List.Item>
                          )}
                        />
                      ),
                      extra: { type: 'count', count: item.children.length },
                    },
                  ]}
                />
              </GroupedListItem>
            )
          return (
            <UngroupedListItem
              paddingLeft={64}
              key={
                item.__typename === 'PayItemConnection'
                  ? item.id
                  : item.__typename === 'ProjectToInternalConnection'
                  ? item.internal.id
                  : item.__typename === 'WorkflowPayItemSummaryConnection'
                  ? item.workflowId
                  : 'this should never hit here'
              }
            >
              {getLabel(item)}
            </UngroupedListItem>
          )
        }}
      />
    </Space>
  )
}

export default Order
